// extracted by mini-css-extract-plugin
module.exports = {"PillContainer":"sponsoredPill_PillContainer__B__vB","pill":"sponsoredPill_pill__GMVqb","messageContainer":"sponsoredPill_messageContainer__lWEpM"};